import FlourishComponent from 'components/FlourishComponent';
import React from 'react';
import { Row, Col } from 'react-bootstrap';

const DistributionAverageVerticalHistogram = (
  {
    containerId = 'distributionAverageVerticalHistogram',
    data,
    title = 'Distribution Average Vertical Histogram',
  },
  ref,
) => {
  const [chartLoaded, setChartLoaded] = React.useState(false);
  if (!data) return null;
  return (
    <Row className='report-second d-flex to-break w-100 p-0'>
      <Col className={`simple-box d-flex flex-column justify-content-center col-12`}>
        <Row className='ml-0'>
          <h5 className='title-simple-box text-uppercase mt-1 pl-0'>{title}</h5>
        </Row>
        <FlourishComponent
          visualizationId='27872262'
          containerId={containerId}
          style={{ width: '100%' }}
          withFooter={false}
          onChartLoad={() => {
            setChartLoaded(true);
          }}
          ref={ref}
          data={{
            bindings: {
              data: {
                label: 0,
                metadata: [],
                value: [1, 2],
              },
            },
            data: {
              data: data || [],
            },
            metadata: {
              data: {
                0: {
                  type_id: 'string$arbitrary_string',
                  type: 'string',
                  output_format_id: 'string$arbitrary_string',
                },
                1: {
                  type_id: 'number$none_point',
                  type: 'number',
                  output_format_id: 'number$comma_point',
                },
                2: {
                  type_id: 'number$none_point',
                  type: 'number',
                  output_format_id: 'number$comma_point',
                },
              },
            },
          }}
          // dataToRespond={[...extractedData.flat()]}
        />
      </Col>
    </Row>
  );
};

export default DistributionAverageVerticalHistogram;
